import { useState } from "react";
import { Button, Box, Modal, Fade, Stack, TextField, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
// ----------------------------------------------------------------------
const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalPaper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #fff',
        boxShadow: '0px 0px 4px #0000001A',
        padding: '2rem',
        borderRadius: '4px',
        textAlign: 'center',
    },
    outlineButton: {
        color: '#85888A',
        fontSize: '14px',
        border: '1px solid #DEDEDE',
        borderRadius: '4px',
        fontWeight: 'normal',
        marginRight: '10px',
        padding: '0.5rem 1.5rem'
    },
    containedButton: {
        color: '#fff',
        fontSize: '14px',
        border: '1px solid #F45E29',
        borderRadius: '4px',
        fontWeight: 'normal',
        padding: '0.5rem 1.5rem'
    }
}));

export default function ReportSaveAsDialog(props) {
    const classes = useStyles();
    const [duplicateReportName, setDuplicateReportName] = useState('')
    const [duplicateReportDesc, setDuplicateReportDesc] = useState('')
    let { openPoup, handleSubmitSaveAs, handleSaveAsPoup } = props

    const handleOnChange = (e) => {
        let { name, value } = e.target
        switch (name) {
            case 'duplicateReportName':
                setDuplicateReportName(value)
                break;
            case 'duplicateReportDesc':
                setDuplicateReportDesc(value)
                break;
        }
    }

    const handleSaveAs = () => {
        handleSubmitSaveAs({ duplicateReportName, duplicateReportDesc })
    }

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className="modal-root"
            open={openPoup}
            closeAfterTransition
        >
            <Fade in={openPoup}>
            <Box className="modal-paper modal-box modal-md" id="transition-modal-title">
                <Box className="modal-header" >
                    <Typography variant="subtitle1" className="modal-header-title" >{`Save report as`}</Typography>
                </Box>
                <Box className="modal-content">
                    <Typography className="text-small label" variant="p">Enter Report Name</Typography>
                    <TextField onChange={handleOnChange} name='duplicateReportName' value={duplicateReportName}  className="report_form_ui_input width-100 mb-1"  placeholder="" /> <br />
                    <Typography className="text-small label" variant="p">Enter Report Description</Typography>
                    <TextField onChange={handleOnChange} name='duplicateReportDesc' value={duplicateReportDesc}  className="report_form_ui_input width-100"  placeholder="" />
                
                    <Box className="modal-footer text-right">
                        <Button onClick={() => handleSaveAsPoup('cancel')} color="error" className="report_form_ui_btn mr-2 cancel" variant="outlined" > Cancel </Button>
                        <Button onClick={handleSaveAs} color="primary" autoFocus className="report_form_ui_btn submit" variant="contained"> Save </Button>
                    </Box>
                </Box>
                
            </Box>
            </Fade>
        </Modal>
    )
}
